import CustomizeDumpChart from './draggable-components/chart/customize-bump-chart';
import CustomizeContentChart from './draggable-components/chart/customize-content-chart';
import CustomizeMultipleScatterChart from './draggable-components/chart/customize-multiple-scatter-chart';
import CustomizeScatterChangeableChart from './draggable-components/chart/customize-scatter-changeable-chart';
import CustomizeTableChart from './draggable-components/chart/customize-table-chart';
import DisplayCabinetChart from './draggable-components/chart/display-cabinet-chart';
import PlaceholderContainer from './draggable-components/container/placeholder-container';
import SelectableTable from './draggable-components/table/selectable-table';
import UnlimitedChatContainer from './draggable-components/container/unlimited-chat-container';
import ButtonTriggerModal from './draggable-components/container/button-trigger-modal';
import AnchorContainer from './draggable-components/basic/anchor';
import ReportComponentContainer from './draggable-components/others/report-component-container';
import NewsContainer from './draggable-components/container/news-container';
import InputContainer from './draggable-components/basic/input';
import AnimationScatterChart from './draggable-components/chart/animation-scatter-chart';
import Customize3DChart from './draggable-components/chart/customize-3d-chart';
import ImageContainer from './draggable-components/basic/image';
import StrategicOptionsListContainer from './draggable-components/others/strategic-option-list-container';
import LogoContainer from './draggable-components/basic/logo';
import FlowContainer from './draggable-components/others/flow-container';
import CustomizeWaterFallChart from './draggable-components/chart/customize-water-fall-chart';
import GroupContainer from './draggable-components/container/group-container';
import ChatList from './draggable-components/container/chat-list';
import DraggableSelect from './draggable-components/basic/draggable-select';
import GenerativePageContainer from './draggable-components/container/generative-page-container';
import StreamChatContainer from './draggable-components/container/stream-chat-container';
import SeriesDataChart from './draggable-components/chart/series-data-chart';
import BasicTable from './draggable-components/table/basic-table';
import ReportComponentExtContainer from './draggable-components/others/report-component-with-socket';
import WaterFallGroupChart from './draggable-components/chart/water-fall-group-chart';
import LabelContainer from './draggable-components/basic/label';
import ForecastHeader from './draggable-components/container/forecast-header';
import ForecastChartGroup from './draggable-components/container/forecast-chart-group';
import CustomizeForecastChart from './draggable-components/chart/customize-forecast-chart';
import ForecastTable from './draggable-components/table/forecast-table';
import CustomizeCompareChart from './draggable-components/chart/customize-compare-chart';
import CompareHeader from './draggable-components/container/compare-header';
import CompareTable from './draggable-components/table/compare-table';
import CustomizeRiskChart from './draggable-components/chart/customize-risk-chart';
import RiskTable from './draggable-components/table/risk-table';
import RiskHeader from './draggable-components/container/risk-header';

const StaticComponentDefinition = {
  WaterFallGroupChart: {
    name: 'WaterFallGroupChart',
    w: 24,
    h: 24,
    padding: '',
    margin: '',
    type: 'WaterFallGroupChart',
    component: <WaterFallGroupChart />,
    title: '',
    subtitle: '',
    titleTag: false,
    titleTagColor: '',
    titleFontSize: '',
    chartOptions: {
      options: JSON.stringify({
        grid: {
          bottom: 40,
          top: 35,
          right: 20,
          left: 40,
        },
        xAxis: {
          type: 'category',
          name: 'xxx',
          nameLocation: 'center',
          scale: true,
          nameGap: 25,
        },
        yAxis: {
          type: 'value',
          name: 'yyy',
          scale: true,
        },
        tooltip: {
          appendToBody: true,
          className: 'overflow-all',
          hideDelay: 0,
          trigger: 'item',
          formatter:
            '(params, ticket, callback) => {\r\n    let value = params.data[2];\r\n    return `<div>${params.marker} ${params.name} <br/>${value}</div>`\r\n}',
        },
        series: [
          {
            name: 'target',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: '(params, ticket, callback) => {\r\n  return params.value[1]+params.value[2];\r\n}',
            },
            itemStyle: {
              color: '#7500c0',
              borderColor: '#7500c0',
              borderWidth: 1,
            },
          },
        ],
      }),
    },
    dataSource: {
      mockData: '[["fy23", 900],["fy24", -100],["fy25", 300],["fy26", 100]]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    tag: 'chart',
  },
  StreamChatContainer: {
    name: 'StreamChatContainer',
    w: 24,
    h: 24,
    padding: '',
    margin: '',
    type: 'StreamChatContainer',
    component: <StreamChatContainer />,
    text: '',
    tag: 'container',
  },
  GenerativePageContainer: {
    name: 'GenerativePageContainer',
    w: 24,
    h: 24,
    padding: '',
    margin: '',
    type: 'GenerativePageContainer',
    component: <GenerativePageContainer />,
    dataSource: {
      mockData: '{"content":"Other Options"}',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    tag: 'container',
  },
  groupContainer: {
    name: 'groupContainer',
    w: 0,
    h: 0,
    padding: '',
    margin: '',
    type: 'groupContainer',
    component: <GroupContainer />,
    tag: 'container',
    children: [
      {
        name: 'basic chart',
        w: 8,
        h: 10,
        padding: '',
        margin: '',
        type: 'chart',
        title: 'chart title',
        subtitle: 'chart sub title',
        titleFontSize: '',
        chartOptions: {},
        dataSource: {
          mockData: '[]',
          api: {
            url: '',
            mockLogic: '',
          },
        },
        component: <CustomizeContentChart />,
        tag: 'chart',
        groupId: `group_${new Date().getTime()}`,
        x: 0,
        y: 0,
      },
      {
        name: 'basic chart',
        w: 8,
        h: 10,
        padding: '',
        margin: '',
        type: 'chart',
        title: 'chart title',
        subtitle: 'chart sub title',
        titleFontSize: '',
        chartOptions: {},
        dataSource: {
          mockData: '[]',
          api: {
            url: '',
            mockLogic: '',
          },
        },
        component: <CustomizeContentChart />,
        tag: 'chart',
        groupId: `group_${new Date().getTime()}`,
        x: 0,
        y: 0,
      },
    ],
    isResizable: false,
  },

  StrategicOptionsListContainer: {
    name: 'StrategicOptionsListContainer',
    w: 4,
    h: 24,
    padding: '',
    margin: '',
    type: 'StrategicOptionsListContainer',
    backgroundImageUrl: '/assets/AI-header.jpg',
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <StrategicOptionsListContainer />,
    tag: 'container',
  },
  AnchorContainer: {
    name: 'AnchorContainer',
    w: 4,
    h: 24,
    padding: '',
    margin: '',
    type: 'AnchorContainer',
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <AnchorContainer />,
    tag: 'container',
  },
  ReportComponentExtContainer: {
    name: 'ReportComponentExtContainer',
    w: 22,
    h: 28,
    padding: '',
    margin: '',
    type: 'ReportComponentExtContainer',
    backgroundImageUrl: '/assets/gai/bg.png',
    data: [],
    component: <ReportComponentExtContainer />,
    tag: 'container',
  },
  ReportContainer: {
    name: 'ReportContainer',
    w: 22,
    h: 28,
    padding: '',
    margin: '',
    type: 'ReportContainer',
    backgroundImageUrl: '/assets/AI-header.jpg',
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <ReportComponentContainer />,
    tag: 'container',
  },
  ChatContainer: {
    name: 'ChatContainer',
    w: 16,
    h: 24,
    padding: '',
    margin: '',
    type: 'ChatContainer',
    dataSource: {
      mockData: '',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <UnlimitedChatContainer />,
    tag: 'container',
  },
  ButtonTriggerModal: {
    name: 'ButtonTriggerModal',
    w: 0,
    h: 0,
    padding: '',
    margin: '',
    type: 'ButtonTriggerModal',
    triggerButtonText: 'trigger',
    triggerButtonIcon: '',
    modalTitle: '',
    triggerEventType: '',
    style: [],
    dataSource: {
      mockData: JSON.stringify([]),
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <ButtonTriggerModal />,
    tag: 'container',
  },
  ChatList: {
    name: 'ChatList',
    w: 8,
    h: 24,
    padding: '',
    margin: '',
    dataSource: {
      mockData: [],
      api: {
        url: '',
        mockLogic: '',
      },
    },
    hideHeaderBar: false,
    type: 'ChatList',
    component: <ChatList />,
    tag: 'container',
  },

  BasicTable: {
    name: 'basic table',
    w: 24,
    h: 12,
    padding: '',
    margin: '',
    type: 'BasicTable',
    title: 'table title',
    addBtnName: '',
    tableHeaderLevelCount: 1,
    tableColumns: {
      columns: [
        {
          key: 'description',
          title: 'Milestones & Critical Paths',
          order: 1,
          renderFormat: 'Customize',
          render: '(text, record, index) => { \n  return record.path ? record.path : record.milestone;\n}',
        },
        {
          key: 'start_date',
          title: 'Start Date',
          dataIndex: 'start_date',
          width: 120,
          renderFormat: 'Date',
          order: 2,
        },
        {
          key: 'end_date',
          title: 'Finish Date',
          dataIndex: 'end_date',
          width: 120,
          renderFormat: 'Date',
          order: 3,
        },
        {
          key: 'float',
          title: 'Float',
          dataIndex: 'float',
          width: 80,
          order: 4,
        },
        {
          key: 'status',
          title: '',
          width: 60,
          renderFormat: 'Arrow',
          order: 5,
        },
      ],
      tableType: 'Simple Table',
    },
    dataSource: {
      mockData:
        '[{"milestone":"P&ID IFP","path":null,"start_date":"2023-03-01","end_date":"2023-06-24","float":17,"arrow_direction":1,"arrow_color":1,"line_color":2,"key":0,"children":[{"milestone":"P&ID IFP","path":"Path-1.1","start_date":"2023-03-15","end_date":"2023-06-24","float":17,"arrow_direction":3,"arrow_color":1,"line_color":2,"key":1},{"milestone":"P&ID IFP","path":"Path-1.2","start_date":"2023-03-29","end_date":"2023-06-20","float":18,"arrow_direction":2,"arrow_color":3,"line_color":2,"key":2},{"milestone":"P&ID IFP","path":"Path-1.3","start_date":"2023-04-12","end_date":"2023-06-19","float":19,"arrow_direction":1,"arrow_color":2,"line_color":2,"key":3},{"milestone":"P&ID IFP","path":"Path-1.4","start_date":"2023-04-29","end_date":"2023-06-18","float":20,"arrow_direction":2,"arrow_color":1,"line_color":2,"key":4}]}]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <BasicTable />,
    tag: 'table',
  },
  table: {
    name: 'basic table',
    w: 24,
    h: 12,
    padding: '',
    margin: '',
    type: 'table',
    title: 'table title',
    addBtnName: '',
    tableHeaderLevelCount: 1,
    tableColumns: {
      columns: [
        {
          key: 'description',
          title: 'Milestones & Critical Paths',
          order: 1,
          renderFormat: 'Customize',
          render: '(text, record, index) => { \n  return record.path ? record.path : record.milestone;\n}',
        },
        {
          key: 'start_date',
          title: 'Start Date',
          dataIndex: 'start_date',
          width: 120,
          renderFormat: 'Date',
          order: 2,
        },
        {
          key: 'end_date',
          title: 'Finish Date',
          dataIndex: 'end_date',
          width: 120,
          renderFormat: 'Date',
          order: 3,
        },
        {
          key: 'float',
          title: 'Float',
          dataIndex: 'float',
          width: 80,
          order: 4,
        },
        {
          key: 'status',
          title: '',
          width: 60,
          renderFormat: 'Arrow',
          order: 5,
        },
      ],
      tableType: 'Simple Table',
    },
    dataSource: {
      mockData:
        '[{"milestone":"P&ID IFP","path":null,"start_date":"2023-03-01","end_date":"2023-06-24","float":17,"arrow_direction":1,"arrow_color":1,"line_color":2,"key":0,"children":[{"milestone":"P&ID IFP","path":"Path-1.1","start_date":"2023-03-15","end_date":"2023-06-24","float":17,"arrow_direction":3,"arrow_color":1,"line_color":2,"key":1},{"milestone":"P&ID IFP","path":"Path-1.2","start_date":"2023-03-29","end_date":"2023-06-20","float":18,"arrow_direction":2,"arrow_color":3,"line_color":2,"key":2},{"milestone":"P&ID IFP","path":"Path-1.3","start_date":"2023-04-12","end_date":"2023-06-19","float":19,"arrow_direction":1,"arrow_color":2,"line_color":2,"key":3},{"milestone":"P&ID IFP","path":"Path-1.4","start_date":"2023-04-29","end_date":"2023-06-18","float":20,"arrow_direction":2,"arrow_color":1,"line_color":2,"key":4}]}]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <SelectableTable />,
    tag: 'table',
  },

  SeriesDataChart: {
    name: 'SeriesDataChart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'SeriesDataChart',
    title: 'chart title',
    subtitle: 'chart sub title',
    titleKey: '',
    titleFontSize: '',
    chartOptions: {},
    component: <SeriesDataChart />,
    tag: 'chart',
  },
  chart: {
    name: 'basic chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    titleKey: '',
    titleFontSize: '',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeContentChart />,
    tag: 'chart',
  },
  'scatter-chart': {
    name: 'scatter chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'scatter-chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeMultipleScatterChart />,
    tag: 'chart',
  },
  'changeable-chart': {
    name: 'changeable scatter',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'changeable-chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeScatterChangeableChart />,
    tag: 'chart',
  },
  'dump-chart': {
    name: 'dump chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'dump-chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeDumpChart />,
    tag: 'chart',
  },
  'table-chart': {
    name: 'table chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'table-chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeTableChart />,
    tag: 'chart',
  },
  'display-cabinet-chart': {
    name: 'Display Cabinet Chart',
    w: 8,
    h: 16,
    padding: '',
    margin: '',
    type: 'display-cabinet-chart',
    title: 'chart title',
    subtitle: 'chart sub title',
    dataSource: {
      mockData: JSON.stringify({
        cabinetWidth: 120,
        cabinetColumnHeight: 30,
        cabinetColumnCount: 6,
        goodsSpace: 2,
        goods: {
          0: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [12, 11.5, 0.5, '4.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [12, 12, 0.3, '6.png'],
          ],
          1: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [7.2, 20, 7.2, '3.png'],
            [12, 11.5, 0.5, '4.png'],
            [12, 11.5, 0.5, '4.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [12, 12, 0.3, '6.png'],
          ],
          2: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [12, 11.5, 0.5, '4.png'],
            [12, 11.5, 0.5, '4.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [12, 12, 0.3, '6.png'],
          ],
          3: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [12, 11.5, 0.5, '4.png'],
            [12, 11.5, 0.5, '4.png'],
            [7, 19, 7, '5.png'],
          ],
          4: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [12, 12, 0.3, '6.png'],
          ],
          5: [
            [4.5, 22, 4.5, '1.png'],
            [4.5, 22, 4.5, '1.png'],
            [6, 20.7, 6, '2.png'],
            [6, 20.7, 6, '2.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [7.2, 20, 7.2, '3.png'],
            [12, 11.5, 0.5, '4.png'],
            [12, 11.5, 0.5, '4.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [7, 19, 7, '5.png'],
            [12, 12, 0.3, '6.png'],
          ],
        },
      }),
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <DisplayCabinetChart />,
    tag: 'chart',
  },
  'forecast-chart': {
    name: 'forecast-chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'forecast-chart',
    title: '',
    subtitle: '',
    titleKey: '',
    titleFontSize: '',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <CustomizeForecastChart />,
    tag: 'chart',
  },
  image: {
    name: 'image',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'image',
    backgroundPosition: 'center center',
    imageUrl: '',
    component: <ImageContainer />,
    tag: 'image',
  },
  logo: {
    name: 'logo',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'logo',
    logoUrl: '/assets/empty-logo.png',
    component: <LogoContainer />,
    tag: 'logo',
  },
  label: {
    name: 'label',
    w: 24,
    h: 1,
    padding: '',
    margin: '',
    type: 'label',
    label: 'Label',
    align: 'left',
    fontSize: 16,
    fontColor: '',
    fontWeight: '',
    component: <LabelContainer />,
    tag: 'label',
  },
  placeholder: {
    name: 'placeholder',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'placeholder',
    title: 'title',
    backgroundPosition: 'center center',
    imageUrl: '',
    useUpload: false,
    component: <PlaceholderContainer />,
    tag: 'placeholder',
  },
  NewsContainer: {
    name: 'NewsContainer',
    w: 24,
    h: 15,
    padding: '',
    margin: '',
    type: 'NewsContainer',
    component: <NewsContainer />,
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    tag: 'container',
  },

  InputContainer: {
    name: 'InputContainer',
    w: 24,
    h: 15,
    padding: '',
    margin: '',
    title: '',
    label: '',
    unit: '',
    buttonName: '',
    eventName: '',
    defaultValue: '',
    inputWidth: '',
    type: 'InputContainer',
    component: <InputContainer />,
    tag: 'container',
  },
  'animation-chart': {
    name: 'animation-chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    type: 'animation-chart',
    title: '',
    subtitle: '',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    component: <AnimationScatterChart />,
    tag: 'chart',
  },
  Customize3dChart: {
    name: 'Customize3dChart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    title: 'chart title',
    subtitle: 'chart sub title',
    chartOptions: {},
    dataSource: {
      mockData: '[]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    type: 'Customize3dChart',
    component: <Customize3DChart />,
    tag: 'chart',
  },
  FlowContainer: {
    name: 'FlowContainer',
    w: 8,
    h: 8,
    type: 'FlowContainer',
    component: <FlowContainer />,
    fontColor: '#000000',
    edgeColor: '#000000',
    dataSource: {
      mockData: '',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    tag: 'container',
  },
  CustomizeWaterFallChart: {
    name: 'Customize-WaterFall-Chart',
    w: 8,
    h: 10,
    padding: '',
    margin: '',
    title: '',
    subtitle: '',
    chartOptions: {
      options: JSON.stringify({
        grid: {
          bottom: 40,
          top: 35,
          right: 20,
          left: 40,
        },
        xAxis: {
          type: 'category',
          name: 'xxx',
          nameLocation: 'center',
          scale: true,
          nameGap: 25,
        },
        yAxis: {
          type: 'value',
          name: 'yyy',
          scale: true,
        },
        tooltip: {
          appendToBody: true,
          className: 'overflow-all',
          hideDelay: 0,
          trigger: 'item',
          formatter:
            '(params, ticket, callback) => {\r\n    let value = params.data[2];\r\n    return `<div>${params.marker} ${params.name} <br/>${value}</div>`\r\n}',
        },
        series: [
          {
            name: 'target',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: '(params, ticket, callback) => {\r\n  return params.value[1]+params.value[2];\r\n}',
            },
            itemStyle: {
              color: '#7500c0',
              borderColor: '#7500c0',
              borderWidth: 1,
            },
          },
        ],
      }),
    },
    dataSource: {
      mockData: '[["fy23", 900],["fy24", -100],["fy25", 300],["fy26", 100]]',
      api: {
        url: '',
        mockLogic: '',
      },
    },
    type: 'CustomizeWaterFallChart',
    component: <CustomizeWaterFallChart />,
    tag: 'chart',
  },
  DraggableSelect: {
    name: 'Draggable Select',
    w: 4,
    h: 1,
    type: 'DraggableSelect',
    component: <DraggableSelect />,
    width: 240,
    placeholder: 'Search to Select',
    multiple: false,
    maxCount: 2,
    showSearch: true,
    disabled: false,
    size: 'middle',
    dataSource: {
      mockData: ['a', 'b', 'c'],
      api: {
        url: '',
        mockLogic: '',
      },
    },
    tag: 'container',
  },
  ForecastHeader: {
    name: 'ForecastHeader',
    w: 24,
    h: 1.5,
    padding: '',
    margin: '',
    algin: '',
    type: 'ForecastHeader',
    filterItems: [],
    triggerWhen: 'ValuesChange',
    triggerEventType: 'FILTER_ITEM_CHANGED',
    component: <ForecastHeader />,
    tag: 'filter',
  },
  ForecastChartGroup: {
    name: 'ForecastChartGroup',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'ForecastChartGroup',
    component: <ForecastChartGroup />,
    chartItems: [{ chartType: 'chart' }],
    tag: 'container',
  },
  ForecastTable: {
    name: 'ForecastTable',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'ForecastTable',
    component: <ForecastTable />,
    tag: 'table',
  },
  CompareHeader: {
    name: 'CompareHeader',
    w: 24,
    h: 1.5,
    padding: '',
    margin: '',
    algin: '',
    type: 'CompareHeader',
    triggerWhen: 'ValuesChange',
    triggerEventType: 'FILTER_ITEM_CHANGED',
    component: <CompareHeader />,
    tag: 'filter',
  },
  CustomizeCompareChart: {
    name: 'CustomizeCompareChart',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'CustomizeCompareChart',
    component: <CustomizeCompareChart />,
    tag: 'chart',
  },
  CompareTable: {
    name: 'CompareTable',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'CompareTable',
    component: <CompareTable />,
    tag: 'table',
  },
  RiskHeader: {
    name: 'CompareHeader',
    w: 24,
    h: 1.5,
    padding: '',
    margin: '',
    algin: '',
    type: 'RiskHeader',
    triggerWhen: 'ValuesChange',
    triggerEventType: 'FILTER_ITEM_CHANGED',
    component: <RiskHeader />,
    tag: 'filter',
  },
  CustomizeRiskChart: {
    name: 'CustomizeRiskChart',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'CustomizeRiskChart',
    component: <CustomizeRiskChart />,
    tag: 'chart',
  },
  RiskTable: {
    name: 'RiskTable',
    w: 24,
    h: 10,
    padding: '',
    margin: '',
    type: 'RiskTable',
    component: <RiskTable />,
    tag: 'table',
  },
};
let CustomComponentDefinition = {};
const definition = localStorage.getItem('CustomComponentDefinition');
if (definition) {
  CustomComponentDefinition = JSON.parse(definition);
  for (const key in CustomComponentDefinition) {
    if (Object.prototype.hasOwnProperty.call(CustomComponentDefinition, key)) {
      CustomComponentDefinition[key].component = StaticComponentDefinition[CustomComponentDefinition[key].copyFrom].component;
    }
  }
}

export const componentDefinition = {
  StaticComponentDefinition,
  CustomComponentDefinition,
};
